import { render, staticRenderFns } from "./landMark.vue?vue&type=template&id=889d9b32&scoped=true&"
import script from "./landMark.vue?vue&type=script&lang=js&"
export * from "./landMark.vue?vue&type=script&lang=js&"
import style0 from "./landMark.vue?vue&type=style&index=0&id=889d9b32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889d9b32",
  null
  
)

export default component.exports